export const ICONS_OPACITY = 0.6;
export const FONTS_OPACITY = 0.6;
export const FONTS_MORE_OPACITY = 0.78;
